import {getWocheFromVsList} from "./einkommensschutz-strecke-actions"
import _ from "lodash"

const BRUTTO_NETTO_BOTTOM_LABEL = "Brutto    Netto"
const VERSORGUNGSLUECKE = "Versorgungslücke"

export const nonNegative = (value) => {
    const num = Number.isNaN(Number(value)) ? 0 : Number(value)
    return Math.max(num, 0)
}

const pflegeChartMapper = (result, art, key) => {
    return result?.find((el) => el.art === art)?.[key] ?? 0
}

const pflegeChartDataBuilder = (result, art, key) =>
    result.reduce(
        (acc, currentSet) =>
            [...acc, currentSet.art.includes(art) && currentSet?.[key]].filter(
                (el) => el || el === 0,
            ),
        [],
    )

export const pflegeBarchartMapper = (result, theme) =>
    result && {
        bottomLabels: [
            "Pflegegrad 1",
            "Pflegegrad 2",
            "Pflegegrad 3",
            "Pflegegrad 4",
            "Pflegegrad 5",
        ],
        datasets: [
            {
                label: "Ist ambulant",
                backgroundColor: theme?.Schiessplatz.barChart.primary,
                data: pflegeChartDataBuilder(result, "PFLEGE_AMBULANT", "ist"),
                stack: "0",
            },
            {
                label: "Ist stationär",
                backgroundColor: theme?.Schiessplatz.barChart.primary,
                data: pflegeChartDataBuilder(
                    result,
                    "PFLEGE_STATIONAER",
                    "ist",
                ),
                stack: "1",
            },
            {
                label: "Lücke ambulant",
                backgroundColor: theme?.Schiessplatz.barChart.secondary,
                data: pflegeChartDataBuilder(
                    result,
                    "PFLEGE_AMBULANT",
                    "luecke",
                ),
                stack: "0",
            },
            {
                label: "Lücke stationär",
                backgroundColor: theme?.Schiessplatz.barChart.secondary,
                data: pflegeChartDataBuilder(
                    result,
                    "PFLEGE_STATIONAER",
                    "luecke",
                ),
                stack: "1",
            },
        ],
    }

const generatePflegestufen = (result, artNummerAlsString, theme) => ({
    istAmbulant: pflegeChartMapper(
        result,
        `PFLEGE_AMBULANT_${artNummerAlsString}`,
        "ist",
    ),
    istStationaer: pflegeChartMapper(
        result,
        `PFLEGE_STATIONAER_${artNummerAlsString}`,
        "ist",
    ),
    stationaer: result?.find(
        (el) => el.art === `PFLEGE_STATIONAER_${artNummerAlsString}`,
    ),
    ambulant: result?.find(
        (el) => el.art === `PFLEGE_AMBULANT_${artNummerAlsString}`,
    ),
    donut: {
        labels: DONUT_LABELS,
        data: {
            hex: theme?.Schiessplatz.donut.primary,
            valPrimary: pflegeChartMapper(
                result,
                `PFLEGE_STATIONAER_${artNummerAlsString}`,
                "ist",
            ),
            valSecondary: pflegeChartMapper(
                result,
                `PFLEGE_STATIONAER_${artNummerAlsString}`,
                "luecke",
            ),
            valTertiary: pflegeChartMapper(
                result,
                `PFLEGE_STATIONAER_${artNummerAlsString}`,
                "neueVersorgungNetto",
            ),
        }
    },
    chartData: {
        datasets: [
            {
                data: [
                    pflegeChartMapper(
                        result,
                        `PFLEGE_AMBULANT_${artNummerAlsString}`,
                        "ist",
                    ),
                    pflegeChartMapper(
                        result,
                        `PFLEGE_STATIONAER_${artNummerAlsString}`,
                        "ist",
                    ),
                ],
                label: "Ist",
                backgroundColor: theme?.Schiessplatz.barChart.primary,
            },
            {
                data: [
                    pflegeChartMapper(
                        result,
                        `PFLEGE_AMBULANT_${artNummerAlsString}`,
                        "luecke",
                    ),
                    pflegeChartMapper(
                        result,
                        `PFLEGE_STATIONAER_${artNummerAlsString}`,
                        "luecke",
                    ),
                ],
                label: "Lücke",
                backgroundColor: theme?.Schiessplatz.barChart.secondary,
            },
        ],
        topLabels: ["ambulant*", "stationär**"],
        bottomLabels: ["", ""],
    },
})

const DONUT_LABELS = ["Ist", "Neu", "Lücke"]

const BERECHNUNGSVORGABEN_ACCORDEON = {
    "HINTERBLIEBENEN": "berechnungsVorgabenVersorgungssituationHibli",
    "INVALIDITAETVOLLEEM": "berechnungsVorgabenArbeitssicherungVolleErwerbsminderung",
    "ALTER": "berechnungsVorgabenAlter",
    "PFLEGE": "berechnungsVorgabenPflege"
}

const BERECHNUNGSVORGABEN = {
    ...BERECHNUNGSVORGABEN_ACCORDEON,
    "VERMOEGEN": "berechnungsVorgabenVermoegen",
    "EIGENHEIM": "berechnungsVorgabenEigenheim",
}

const itemsToRemove = new Set(["VERMOEGEN", "EIGENHEIM"])

export const SchiessplatzActions = ({
                                        getDataFromPointer,
                                        sendDataToBackend,
                                        updateData,
                                        theme,
                                        sendFileToBackend,
                                        triggerAction,
                                    }) => {
    const buildGehaltSlice = (result) => {
        const gehaltData = {
            barChart: {
                topLabels: ["Brutto", "Netto"],
                bottomLabels: ["", ""],
                datasets: [
                    {
                        label: "Brutto",
                        data: [Number(result?.monatlichesBruttoEinkommen), null],
                        backgroundColor: "#3A6399",
                    },
                    {
                        label: "Netto",
                        data: [null, Number(result?.monatlichesNettoEinkommen)],
                        backgroundColor: "#9B92C6",
                    },
                ],
            },
            brutto: result?.monatlichesBruttoEinkommen,
            netto: result?.monatlichesNettoEinkommen,
        }
        updateData(gehaltData, "/schiessplatz/themenfelder/GEHALT")
    }

    const buildSliceData = (slice, target) => {
        const result = target ? slice?.[target] : slice

        const sliceData = {
            ...result,
            graph: {
                labels: DONUT_LABELS,
                data: {
                    hex: theme?.Schiessplatz?.donut?.primary,
                    valPrimary: nonNegative(result?.ist),
                    valSecondary: nonNegative(result?.luecke),
                    valTertiary: nonNegative(result?.neueVersorgungNetto),
                }
            },
            barChart: {
                bottomLabels: [""],
                datasets: [
                    {
                        label: "Ist",
                        data: [nonNegative(result?.ist)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    },
                    {
                        label: "Neu",
                        data: [nonNegative(result?.neueVersorgungNetto)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.tertiary,
                    },
                    {
                        label: "Lücke",
                        data: [nonNegative(result?.luecke)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.secondary,
                    },
                ],
            },
        }
        updateData(sliceData, `/schiessplatz/themenfelder/${result?.art}`)
    }

    const pflegeMapperFunction = (result) => {
        const mappedResult = {
            pflegestufeEins: generatePflegestufen(result, "EINS", theme),
            pflegestufeZwei: generatePflegestufen(result, "ZWEI", theme),
            pflegestufeDrei: generatePflegestufen(result, "DREI", theme),
            pflegestufeVier: generatePflegestufen(result, "VIER", theme),
            pflegestufeFuenf: generatePflegestufen(result, "FUENF", theme),
            luecke: pflegeChartMapper(result, `PFLEGE_STATIONAER_FUENF`, "luecke"),
            ziel: pflegeChartMapper(result, `PFLEGE_STATIONAER_FUENF`, "ziel"),
            ist: pflegeChartMapper(result, `PFLEGE_STATIONAER_FUENF`, "ist"),
            detailsBarChart: pflegeBarchartMapper(result, theme),
            barChart: {
                topLabels: ["Pflegestufe 5 Stationär"],
                datasets: [
                    {
                        data: [
                            pflegeChartMapper(
                                result,
                                `PFLEGE_STATIONAER_FUENF`,
                                "ist",
                            ),
                        ],
                        label: "Ist",
                        backgroundColor: theme?.Schiessplatz.barChart.primary,
                    },
                    {
                        data: [
                            pflegeChartMapper(
                                result,
                                `PFLEGE_STATIONAER_FUENF`,
                                "luecke",
                            ),
                        ],
                        label: "Lücke",
                        backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    },
                ],
            },
        }
        updateData(mappedResult, "/schiessplatz/themenfelder/PFLEGE")
    }

    const buildArbeitsunfaehigkeitData = (slice, target) => {
        const result = target ? slice?.[target] : slice
        const ktgWoche7 = getWocheFromVsList(result?.versorgungssituationList, "KTG_WOCHE_SIEBTE")

        const sliceData = {
            ...result,
            graph: {
                labels: DONUT_LABELS,
                data: {
                    hex: theme?.Schiessplatz?.donut?.primary,
                    valPrimary: nonNegative(ktgWoche7?.ist),
                    valSecondary: nonNegative(ktgWoche7?.luecke),
                    valTertiary: nonNegative(ktgWoche7?.neu),
                }
            },
            barChart: {
                bottomLabels: [""],
                datasets: [
                    {
                        label: "Ist",
                        data: [nonNegative(ktgWoche7?.ist)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    },
                    {
                        label: "Invest",
                        data: [nonNegative(ktgWoche7?.neueVersorgungNetto)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.tertiary,
                    },
                    {
                        label: "Lücke",
                        data: [nonNegative(ktgWoche7?.luecke)],
                        backgroundColor: theme?.Schiessplatz?.barChart?.secondary,
                    },
                ],
            },
            ...ktgWoche7,
        }
        updateData(sliceData, "/schiessplatz/themenfelder/KTG_WOCHE_SIEBTE")
    }

    const ZIELSCHEIBE_RINGS = [
        {key: "ALTER", label: "Altersvorsorge", ring: "ring1"},
        {key: "INVALIDITAETVOLLEEM", label: "Einkommensschutz", ring: "ring2"},
        {key: "HINTERBLIEBENEN", label: "Hinterbliebenenschutz", ring: "ring3"},
    ]

    const buildZielscheibeGraph = () => {
        const graph = ZIELSCHEIBE_RINGS.map(({key, label, ring}) => {
            const tf = getDataFromPointer(`/schiessplatz/themenfelder/${key}`) ?? {}
            return {
                label,
                hex: theme?.ZIELSCHEIBE?.[ring],
                valPrimary: nonNegative(tf.ist),
                valSecondary: nonNegative(tf.luecke),
            }
        })
        updateData(graph, "/versorgungsuebersicht/graph")
    }

    const calcBudget = () => {
        const isStandalone = getDataFromPointer("/appstate/standalone")
        const themenfelder = getDataFromPointer("/schiessplatz/themenfelder") ?? {}
        const selectedThemenfelder = getDataFromPointer("/schiessplatz/selectedThemenfelder") ?? []

        const filteredSelectedThemenfelder = isStandalone
            ? selectedThemenfelder
            : selectedThemenfelder.filter(item => !itemsToRemove.has(item))

        const berechnungsvorgabenList = _(isStandalone ? BERECHNUNGSVORGABEN : BERECHNUNGSVORGABEN_ACCORDEON)
            .pick(filteredSelectedThemenfelder)
            .values()
            .value()
        const berechnungsvorgaben = _(getDataFromPointer(""))
            .pick(berechnungsvorgabenList)
            .values()
            .value()

        const pickedThemenfelder = _.pick(themenfelder, filteredSelectedThemenfelder)

        const budget = getDataFromPointer("/kundeNp/budget") ?? 0

        const aufwand = _(pickedThemenfelder)
            .values()
            .sumBy("aufwandLueckenschlussMonatlichEuro")
        const gesamtInvest = _.sumBy(berechnungsvorgaben, item => item?.invest ?? 0)
        const restBudget = budget - gesamtInvest

        updateData(aufwand, "/schiessplatz/additionalValues/gesamtAufwand")
        updateData(gesamtInvest, "/schiessplatz/additionalValues/gesamtInvest")
        updateData(restBudget, "/schiessplatz/additionalValues/restVerfuegbar")
    }

    const calculateSchiessstand = (response) => {
        buildGehaltSlice(response?.ergebnisGehalt)
        buildSliceData(
            response?.ergebnisAlter,
            "kunde"
        )
        buildSliceData(
            response?.ergebnisArbeitssicherungOhneErwerbsminderung,
            "kunde"
        )
        buildArbeitsunfaehigkeitData(
            response?.ergebnisKrankentagegeld,
            "kunde"
        )
        buildSliceData(
            response?.ergebnisArbeitssicherungVolleErwerbsminderung,
            "kunde"
        )
        buildSliceData(
            response?.ergebnisArbeitssicherungHalbeErwerbsminderung,
            "kunde"
        )
        buildSliceData(
            response?.ergebnisVermoegen,
        )
        buildSliceData(
            response?.ergebnisEigenheim,
        )
        buildSliceData(
            response?.ergebnisVersorgungssituationHibli
        )
        pflegeMapperFunction(
            response?.ergebnisPflege
        )

        const detailChartData = {
            bottomLabels: ["Brutto Netto", "Lohnfortzahlung Krankengeld"],
            datasets: [
                {
                    label: "Brutto",
                    data: [response?.ergebnisGehalt?.monatlichesBruttoEinkommen, null],
                    backgroundColor: "#3A6399",
                    stack: "stack1",
                },
                {
                    label: "Netto",
                    data: [response?.ergebnisGehalt?.monatlichesNettoEinkommen, null],
                    backgroundColor: "#9B92C6",
                    stack: "stack2",
                },
                {
                    label: "Ist",
                    data: [
                        null,
                        response?.ergebnisKrankentagegeld?.kunde?.versorgungssituationList?.find(
                            (el) => el.art === "KTG_WOCHE_SECHSTE",
                        )?.nettoeinkommen,
                    ],
                    backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    stack: "stack1",
                },
                {
                    label: "Ist",
                    data: [null, response?.ergebnisKrankentagegeld?.kunde?.woche7gesetzlicheVersorgungNettoMonat],
                    backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    stack: "stack2",
                },
                {
                    label: "Lücke",
                    data: [null, response?.ergebnisKrankentagegeld?.kunde?.woche7versorgungslueckeNettoMonat],
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "stack2",
                },
            ],
        }

        const erwerbsunfaehigkeitDetailChartData = {
            bottomLabels: [
                BRUTTO_NETTO_BOTTOM_LABEL,
                "         Erwerbsminderungsrente",
            ],
            datasets: [
                {
                    data: [response?.ergebnisGehalt?.monatlichesBruttoEinkommen],
                    label: "Brutto",
                    backgroundColor: "#3A6399",
                    stack: "0",
                },
                {
                    data: [response?.ergebnisGehalt?.monatlichesNettoEinkommen],
                    label: "Netto",
                    backgroundColor: "#626262",
                    stack: "1",
                },
                {
                    data: [null, response?.ergebnisArbeitssicherungVolleErwerbsminderung?.kunde?.ist],
                    label: "Erwerbsminderungsrente",
                    backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    stack: "1",
                },
                {
                    data: [null, response?.ergebnisArbeitssicherungVolleErwerbsminderung?.kunde?.luecke],
                    label: VERSORGUNGSLUECKE,
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "1",
                },
            ],
        }

        const buDetailChartData = {
            bottomLabels: [
                "Brutto   Netto",
                ["bei", "Berufsunfähigkeit"],
                "Freizeitunfall",
            ],
            datasets: [
                {
                    data: [response?.ergebnisGehalt?.monatlichesBruttoEinkommen],
                    label: "Brutto",
                    backgroundColor: "#3A6399",
                    stack: "1",
                },
                {
                    data: [response?.ergebnisGehalt?.monatlichesNettoEinkommen],
                    label: "Netto",
                    backgroundColor: "#626262",
                    stack: "0",
                },
                {
                    data: [null, response?.ergebnisArbeitssicherungOhneErwerbsminderung?.kunde?.luecke],
                    label: "bei Berufsunfähigkeit",
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "1",
                },
                {
                    data: [null, null, response?.ergebnisArbeitssicherungOhneErwerbsminderung?.kunde?.luecke],
                    label: "Freizeitunfall",
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "0",
                },
            ],
        }

        const hibliDetailChartData = {
            bottomLabels: [
                BRUTTO_NETTO_BOTTOM_LABEL,
                "         Hinterbliebenenrente",
            ],
            datasets: [
                {
                    data: [response?.ergebnisGehalt?.monatlichesBruttoEinkommen],
                    label: "Brutto",
                    backgroundColor: "#3A6399",
                    stack: "0",
                },
                {
                    data: [response?.ergebnisGehalt?.monatlichesNettoEinkommen],
                    label: "Netto",
                    backgroundColor: "#626262",
                    stack: "1",
                },
                {
                    data: [null, response?.ergebnisVersorgungssituationHibli?.ist],
                    label: "Hinterbliebenenrente",
                    backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    stack: "1",
                },
                {
                    data: [null, response?.ergebnisVersorgungssituationHibli?.luecke],
                    label: VERSORGUNGSLUECKE,
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "1",
                },
            ],
        }

        const avDetailChart = {
            bottomLabels: [BRUTTO_NETTO_BOTTOM_LABEL, "Altersrente"],
            datasets: [
                {
                    data: [response?.ergebnisGehalt?.monatlichesBruttoEinkommen],
                    label: "Brutto",
                    backgroundColor: "#3A6399",
                    stack: "0",
                },
                {
                    data: [response?.ergebnisGehalt?.monatlichesNettoEinkommen],
                    label: "Netto",
                    backgroundColor: "#626262",
                    stack: "1",
                },
                {
                    data: [null, response?.ergebnisAlter?.kunde?.ist],
                    label: "Altersrente",
                    backgroundColor: theme?.Schiessplatz?.barChart?.primary,
                    stack: "0",
                },
                {
                    data: [null, response?.ergebnisAlter?.kunde?.luecke],
                    label: VERSORGUNGSLUECKE,
                    backgroundColor: theme?.Schiessplatz.barChart.secondary,
                    stack: "0",
                },
            ],
        }

        updateData(detailChartData, "/schiessplatz/themenfelder/KTG_WOCHE_SIEBTE/detailChartData")
        updateData(
            buDetailChartData,
            "/schiessplatz/themenfelder/INVALIDITAETBU/detailChartData",
        )
        updateData(
            hibliDetailChartData,
            "/schiessplatz/themenfelder/HINTERBLIEBENEN/detailChartData",
        )
        updateData(
            erwerbsunfaehigkeitDetailChartData,
            "/schiessplatz/themenfelder/INVALIDITAETVOLLEEM/detailChartData",
        )
        updateData(avDetailChart, "/schiessplatz/themenfelder/ALTER/detailChartData")

        calcBudget()
        buildZielscheibeGraph()
    }

    return {
        INIT_SCHIESSPLATZ: () => {
            updateData(true, "/appstate/standalone")
            calcBudget()
        },
        CALC_CONTEXTAREA_SCHIESSSTAND: async (payload) => {
            if (payload?.calcData) {
                calculateSchiessstand(payload.calcData)
                return
            }
            const calcLink = payload?._links?.calculateSchiessstand
            if (!calcLink?.href) {
                console.warn(
                    "[CALC_CONTEXTAREA_SCHIESSSTAND] 'calculateSchiessstand'-Link fehlt im Payload",
                    Object.keys(payload?._links ?? {}),
                )
                return
            }
            const {_data: response = {}} = await sendDataToBackend(calcLink) ?? {}
            calculateSchiessstand(response)
        },
        SCHIESSPLATZ_CHANGE_BUDGET: () => {
            calcBudget()
        },
        OPEN_MODAL_AV: () => {
            updateData(true, "/appstate/schiessplatz/avModalOpen")
        },
        OPEN_MODAL_AU: () => {
            updateData(true, "/appstate/schiessplatz/auModalOpen")
        },
        OPEN_MODAL_HI: () => {
            updateData(true, "/appstate/schiessplatz/hiModalOpen")
        },
        CLOSE_MODAL_AV: () => {
            updateData(false, "/appstate/schiessplatz/avModalOpen")
        },
        CLOSE_MODAL_AU: () => {
            updateData(false, "/appstate/schiessplatz/auModalOpen")
        },
        CLOSE_MODAL_HI: () => {
            updateData(false, "/appstate/schiessplatz/hiModalOpen")
        },
        OPEN_MODAL_HAUS: () => {
            updateData(true, "/appstate/schiessplatz/hausModalOpen")
        },
        CLOSE_MODAL_PFLEGE: () => {
            updateData(false, "/appstate/schiessplatz/pflegeModalOpen")
        },
        OPEN_MODAL_VERMOEGEN: () => {
            updateData(true, "/appstate/schiessplatz/vermoegenDialogOpen")
        },
        CLOSE_MODAL_VERMOEGEN: () => {
            const prevData = getDataFromPointer(
                "/appstate/schiessplatz/vermoegen/berechnungsvorgaben",
            )

            updateData(
                prevData,
                "/appstate/schiessplatz/vermoegenDialogLocalState",
            )
            updateData(false, "/appstate/schiessplatz/vermoegenDialogOpen")
        },
        SAVE_VERMOEGEN_DATA: () => {
            const currentData = getDataFromPointer(
                "/appstate/schiessplatz/vermoegen/berechnungsvorgaben",
            )
            const newData = getDataFromPointer(
                "/appstate/schiessplatz/vermoegenDialogLocalState",
            )

            updateData(
                {...currentData, ...newData},
                "/appstate/schiessplatz/vermoegen/berechnungsvorgaben",
            )
            updateData(false, "/appstate/schiessplatz/vermoegenDialogOpen")
        },
        OPEN_MODAL_EIGENHEIM: () => {
            updateData(true, "/appstate/schiessplatz/eigenheimDialogOpen")
        },
        CLOSE_MODAL_EIGENHEIM: () => {
            const prevData = getDataFromPointer(
                "/appstate/schiessplatz/eigenheim/berechnungsvorgaben",
            )

            updateData(
                prevData,
                "/appstate/schiessplatz/eigenheimDialogLocalState",
            )
            updateData(false, "/appstate/schiessplatz/eigenheimDialogOpen")
        },
        SAVE_EIGENHEIM_DATA: () => {
            const currentData = getDataFromPointer(
                "/appstate/schiessplatz/eigenheim/berechnungsvorgaben",
            )
            const newData = getDataFromPointer(
                "/appstate/schiessplatz/eigenheimDialogLocalState",
            )

            updateData(
                {...currentData, ...newData},
                "/appstate/schiessplatz/eigenheim/berechnungsvorgaben",
            )
            updateData(false, "/appstate/schiessplatz/eigenheimDialogOpen")
        },
        OPEN_AV_FORM: () => {
            updateData(true, "/appstate/schiessplatz/avFormOpen")
        },
        OPEN_HI_FORM: () => {
            updateData(true, "/appstate/schiessplatz/hiFormOpen")
        },
        OPEN_AU_FORM: () => {
            updateData(true, "/appstate/schiessplatz/auFormOpen")
        },
        CLOSE_AV_FORM: () => {
            updateData(false, "/appstate/schiessplatz/avFormOpen")
        },
        OPEN_PFLEGE_FORM: () => {
            updateData(true, "/appstate/schiessplatz/pflegeModalOpen")
        },
        CLOSE_PFLEGE_FORM: () => {
            updateData(false, "/appstate/schiessplatz/pflegeModalOpen")
        },
        CLOSE_HI_FORM: () => {
            updateData(false, "/appstate/schiessplatz/hiFormOpen")
        },
        CLOSE_AU_FORM: () => {
            updateData(false, "/appstate/schiessplatz/auFormOpen")
        },
        CLOSE_AND_CALC_AV_FORM: () => {
            updateData(false, "/appstate/schiessplatz/avFormOpen")
        },
        CLOSE_AND_CALC_HI_FORM: () => {
            updateData(false, "/appstate/schiessplatz/hiFormOpen")
        },
        CLOSE_AND_CALC_AU_FORM: () => {
            updateData(false, "/appstate/schiessplatz/auFormOpen")
        },
        IMPORT_DRUE: async (file) => {
            if (!file) return
            const fileAsArrayBuffer = await file.arrayBuffer()
            await sendFileToBackend(
                getDataFromPointer("/links/kunde:importDrue"),
                fileAsArrayBuffer,
                "/kunde/bestehendeVersorgung",
                (res, links) => {
                    const oldLinks = getDataFromPointer("/links")
                    updateData({...oldLinks, ...links}, "/links")
                    return res?.kunde?.bestehendeVersorgung
                },
            )
            return triggerAction("REFRESH_ALL_CONTEXTAREAS")
        },
        WEITER: () => {
            const currentpage =
                getDataFromPointer("/schiessplatz/activePage") ?? 0
            updateData(
                String(Number(currentpage) + 1),
                "/schiessplatz/activePage",
            )
        },
        ZURUECK: () => {
            const currentpage =
                getDataFromPointer("/schiessplatz/activePage") ?? 0
            updateData(
                String(Number(currentpage) - 1),
                "/schiessplatz/activePage",
            )
        },
        REDIRECT_FINO: () => {
            window._env_?.MODE === "dev" && console.warn("[WORKNUNIT] wurde entfernt hier könnten probleme auftreten")
            sendDataToBackend(
                getDataFromPointer("/links/kunde:finoLink"),
                {},
                "/links",
                (_, links) => {
                    const oldLinks = getDataFromPointer("/links")
                    const newLinks = {...oldLinks, ...links}
                    globalThis.open(links?.["fino:start"]?.href)
                    updateData("true", "/appstate/finoRedirected")
                    return newLinks
                },
            )
        },
        LOAD_FINO: () => {
            window._env_?.MODE === "dev" && console.warn("[WORKNUNIT] wurde entfernt hier könnten probleme auftreten")
            sendDataToBackend(
                getDataFromPointer("/links/fino:import"),
                {},
                "/fino",
                (data) => {
                    const oldLinks = getDataFromPointer("/links")
                    const newLinks = {...oldLinks, ...data?.links}
                    updateData(newLinks, "/links")
                    return {...data?.snapshot?.kunde}
                },
            )
        },
    }
}
